import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "status-bar" }

import { computed } from "vue";
import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone } from "@/models/applicationStatus";
import NotSubmittedText from "@/components/application-statuses/NotSubmitted/NotSubmittedText.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotSubmitted',
  emits: ["todoListClicked"],
  setup(__props, { emit: __emit }) {

useStore();

const emit = __emit;

const { timeline, currentstep, stepCount } = useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TimelineStep, {
      status: "active",
      step: 1,
      title: "Not Yet Submitted",
      maximumStep: _unref(stepCount)
    }, {
      title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "red" }, "Not Yet Submitted", -1)
      ]))]),
      caption: _withCtx(() => [
        _createVNode(NotSubmittedText)
      ]),
      _: 1
    }, 8, ["maximumStep"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
      return (_openBlock(), _createBlock(TimelineStep, {
        key: step.id,
        status: step.status,
        step: step.step,
        title: step.title,
        maximumStep: _unref(stepCount),
        configuration: step,
        onTitleClicked: _cache[0] || (_cache[0] = ($event: any) => (currentstep.value = $event)),
        onTodoListClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('todoListClicked')))
      }, null, 8, ["status", "step", "title", "maximumStep", "configuration"]))
    }), 128))
  ]))
}
}

})